import { combineReducers } from 'redux';

import {
  setInlineTextInstruction,
  setOpenTextInstructionModal,
  setTextInstructionId,
  setTextTextInstruction,
} from '../actions';
import { ScriptEditorAction, TextInstructionState } from '../types';
import { Reducer } from '../../../types';

type ReducerOf<T extends keyof TextInstructionState> = Reducer<TextInstructionState, ScriptEditorAction, T>;

const isOpenModal: ReducerOf<'isOpenModal'> = (state = false, action) => {
  switch (action.type) {
    case setOpenTextInstructionModal.type:
      return action.payload;

    default:
      return state;
  }
};

const instructionId: ReducerOf<'instructionId'> = (state = '', action) => {
  switch (action.type) {
    case setTextInstructionId.type:
      return action.payload;

    default:
      return state;
  }
};

const text: ReducerOf<'text'> = (state = '', action) => {
  switch (action.type) {
    case setTextTextInstruction.type:
      return action.payload;

    default:
      return state;
  }
};

const isInline: ReducerOf<'isInline'> = (state = true, action) => {
  switch (action.type) {
    case setInlineTextInstruction.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers({
  isOpenModal,
  isInline,
  instructionId,
  text,
});
